import React, { useState, useEffect } from 'react';
import '../css/moodboard-grid.css';
import TileVimeo from './TileVimeo';
import TileVideo from './TileVideo';
import TileAudio from './TileAudio';
import TileYoutube from './TileYoutube';
import TileImage from './TileImage';
import TileWebsite from "./TileWebsite";

export default function MoodboardTiles(props) {

    const [mount, setMount] = useState(false)

    useEffect(() => {
        // code to run on component mount
        setMount(true);
    }, []);

    const renderTiles = () => {
        //const moodboards = props.moodboards.sort((a, b) => a.order - b.order);
        const moodboards = props.moodboards;
        if (mount === false) return <div>Loading</div>

        if (moodboards.length > 0) {
            return moodboards.map(moodboard => {
                if (moodboard.type && moodboard.fileUrl) {
                    if (moodboard.type.includes('image')) {
                        return <TileImage key={moodboard._id} id={moodboard._id} thumbnail={moodboard.thumbnailUrl} src={moodboard.fileUrl} delete={props.delete} view={props.view} />
                    } else if (moodboard.type === 'video') {
                        if (moodboard.fileUrl.includes('youtube'))
                            return <TileYoutube key={moodboard._id} id={moodboard._id} src={moodboard.fileUrl} delete={props.delete} view={props.view} />
                        else if (moodboard.fileUrl.includes('vimeo'))
                            return <TileVimeo key={moodboard._id} id={moodboard._id} src={moodboard.fileUrl} delete={props.delete} view={props.view} />
                        else if (moodboard.fileUrl.includes('filmboard.s3'))
                            return <TileVideo key={moodboard._id} id={moodboard._id} image={moodboard.thumbnailUrl} src={moodboard.fileUrl} delete={props.delete} view={props.view} />
                        else
                            return <TileVideo key={moodboard._id} id={moodboard._id} image={moodboard.thumbnailUrl} src={moodboard.fileUrl} delete={props.delete} view={props.view} />
                    } else if (moodboard.type === 'audio') {
                        return <TileAudio key={moodboard._id} id={moodboard._id} src={moodboard.fileUrl} delete={props.delete} view={props.view} />
                    } else if (moodboard.type === 'pexels-video') {
                        return <TileVideo key={moodboard._id} id={moodboard._id} image={moodboard.thumbnailUrl} src={moodboard.fileUrl} delete={props.delete} view={props.view} />
                    } else if (moodboard.type === 'website') {
                        return <TileWebsite key={moodboard._id} id={moodboard._id} image={moodboard.thumbnailUrl} src={moodboard.fileUrl} delete={props.delete} view={props.view} moodboard={moodboard} />
                    }
                }
            });
        }
        else {
            return <div className="container-fluid not-found">No moodboards found.</div>;
        }
    }

    return (
        renderTiles()
    );
}